<template>
	<div class="row">
		<div class="col-md-12" style="margin-top: 30px">
			<a :href="pliDomain" target="_blank">
				<img style="margin: 0 auto;" class="img-responsive" :src="logoUrl" />
			</a>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import * as appConfigs from '../configs'

	export default {
		computed: {
			logoUrl() {
				return appConfigs.logoUrl
			},
			pliDomain() {
				return appConfigs.pliDomain
			}
		}
	}
</script>